import { OperationalEquipmentDto } from '@operations/app/api'
import { useTranslate } from '@tolgee/react'
import { TomTableActionsProps } from '@tom-ui/ui'
import { MRT_Row } from 'material-react-table'
import { useCallback } from 'react'
import { useNavigate } from 'react-router'

export const useOperationEquipmentTableActions = () => {
  const { t } = useTranslate()
  const navigate = useNavigate()

  return useCallback(
    (
      selectedRows: MRT_Row<OperationalEquipmentDto>[],
    ): TomTableActionsProps<OperationalEquipmentDto>[] => {
      const items = selectedRows.map(row => row.original)

      return [
        {
          label: t('edit', 'Edit'),
          grouped: true,
          onClick: () => navigate(`${items.map(item => item.id).join(',')}`),
        },
      ]
    },
    [t],
  )
}
